import { useEffect, useState } from "react";

const usePollResults = (firebaseApp, pageId) => {
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!firebaseApp || !pageId) {
			setLoading(false);
			return;
		}

		setLoading(true);

		const db = firebaseApp.firestore();
		const resultsRef = db
			.collection("polls")
			.doc(pageId)
			.collection("results");

		const unsubscribe = resultsRef.onSnapshot(snapshot => {
			const pollResults = [];
			snapshot.forEach(doc => {
				pollResults.push(doc.data());
			});
			setResults(pollResults);
			setLoading(false);
		});

		return () => unsubscribe();
	}, [firebaseApp, pageId]);

	return { results, loading };
};

export default usePollResults;
